import React, { Component } from 'react';
import { Text } from 'components/tt-forms/common';
import { Link } from 'react-router';
import { Dialog } from "@blueprintjs/core";
import TextTruncate from 'react-text-truncate';
import { isEmpty, get } from 'lodash';

export default class RowItemChiTietNoiDungTTT extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    }
  }

  closeDialog() {
    this.setState({
      isOpen: false
    });
  }

  onOpenDialog() {
    this.setState({
      isOpen: true
    });
  }

  render() {
    const { count } = this.props;
    const { cuocThanhTras, doiTuongThanhTraTrung, namThanhTra } = this.props.item;
    const LisData = cuocThanhTras.map((item, index) => {
      if (index === 0) {
        return (
          <tr key={index}>
            <td rowSpan={cuocThanhTras.length}>{count}</td>
            <td rowSpan={cuocThanhTras.length} className='txt-underline'>
              <Link className='txt-underline txt-regular' onClick={this.onOpenDialog.bind(this)}>{doiTuongThanhTraTrung.ten || ''}</Link>
              <Dialog
                isOpen={this.state.isOpen}
                onClose={this.closeDialog.bind(this)}
                title='Thông tin đối tượng thanh tra, kiểm tra'
                className="dialog-default wrap-block">
                <div className='row pl30 pr30 pt20'>
                  <Text
                    className="col-50 mb10"
                    label="Tên đối tượng:"
                    value={doiTuongThanhTraTrung.ten || ''} />
                  <Text
                    className="col-50 mb10"
                    label="Nhóm đối tượng:"
                    value={get(doiTuongThanhTraTrung, 'nhomDoiTuongThanhTraInfo.ten')} />
                  <Text
                    className="col-50 mb10"
                    label="Huyện/TP:"
                    value={get(doiTuongThanhTraTrung, 'quanHuyenInfo.name')} />
                  <Text
                    className="col-50 mb10"
                    label="Phường/Xã:"
                    value={get(doiTuongThanhTraTrung, 'phuongXaInfo.name')} />
                  <Text
                    className="col-50 mb10"
                    label="Địa chỉ:"
                    value={doiTuongThanhTraTrung.diaChi || ''} />
                  <Text
                    className="col-50 mb10"
                    label="Số điện thoại:"
                    value={doiTuongThanhTraTrung.soDienThoai || ''} />
                  <Text
                    className="col-50 mb10"
                    label="Ghi chú:"
                    value={doiTuongThanhTraTrung.ghiChu || ''}
                    />
                </div>
              </Dialog>
            </td>
            <td>{get(item, 'donViInfo.ten') || ''}</td>
            <td className='txt-center'>{get(item, 'quyetDinhPheDuyetKTTT') || ''}</td>
            <td rowSpan={cuocThanhTras.length}>{namThanhTra || ''}</td>
            <td>
              <Link className='txt-underline text-color-default' to={`/thanh-tra/cuoc-thanh-tra-trung/chi-tiet/${get(item, 'idCuocThanhTra')}`}>
                {
                  !isEmpty(item.tenCuocThanhTra) &&
                  <TextTruncate
                    line={3}
                    truncateText="…"
                    text={get(item, 'tenCuocThanhTra')} />
                }
              </Link>
              <div className='mt10'>{get(item, 'soDoiTuong')} đối tượng</div>
            </td>
            <td rowSpan={cuocThanhTras.length}>
              <div className="mgbt10">Đề xuất chuyên viên xử lý: </div>
              <Text className='col-100 mb10' value={get(this.props.item, 'noiDungChuyenVienDeXuat') || ''} />
            </td>
            <td>{get(item, 'kyThanhTra') || ''}</td>
            <td>{get(item, 'trangThaiXuLyTrungTaiDonViInfo.text')}</td>
          </tr>
        )
      }
      return (
        <tr key={index}>
          <td className='bg-white txt-left'>{get(item, 'donViInfo.ten') || ''}</td>
          <td className='bg-white txt-center'>{get(item, 'quyetDinhPheDuyetKTTT') || ''}</td>
          <td className='bg-white'>
            <Link className='txt-underline text-color-default' to={'/thanh-tra/cuoc-thanh-tra-trung/chi-tiet/' + get(item, 'idCuocThanhTra')}>
              {
                !isEmpty(item.tenCuocThanhTra) &&
                <TextTruncate
                  line={3}
                  truncateText="…"
                  text={get(item, 'tenCuocThanhTra')} />
              }
            </Link>
            <div className='mt10'>{get(item, 'soDoiTuong')} đối tượng</div>
          </td>
          <td className='bg-white txt-left'>{get(item, 'kyThanhTra') || ''}</td>
          <td className='bg-white txt-left'>{get(item, 'trangThaiXuLyTrungTaiDonViInfo.text')}</td>
        </tr>
      )
    })
    return (
      <tbody className="table-body">
        {LisData}
      </tbody>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra-trung/datatable/RowItemChiTietNoiDungTTT.jsx